import React, { useState, ReactElement } from "react";
// import { TailSpin } from "react-loader-spinner";
// import Loader  from "react-loader-spinner";
import "../../Styles/StyledComps.css";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

interface IProps {
  isLoading: boolean;
}

const LoaderComponent: React.FC = () => {
  const isShowLoader = useSelector(
    (state: RootState) => state.api.isShowLoader
  );
  const primaryColor = "#366287";
  return (
    <></>
    // <Loader  type="TailSpin"  color="rgb(155, 236, 34)"  height={70} width={70} timeout={5000} />
    // <div className="position-relative">
    // <div className="position-absolute top-50 start-50 translate-middle">
    //   <TailSpin
    //     height="80"
    //     width="80"
    //     color={primaryColor}
    //     ariaLabel="tail-spin-loading"
    //     radius="1"
    //     wrapperStyle={{}}
    //     wrapperClass=""
    //     visible={isShowLoader}
    //   />
    // </div>
    //  </div>
  );
};

export default LoaderComponent;
